var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"image-comp"},[_c('img',{class:{ pointer: _vm.eject },attrs:{"src":_vm.fullSrc,"width":_vm.width,"height":_vm.height},on:{"click":_vm.newWindow}})])
}
var staticRenderFns = []

export { render, staticRenderFns }